module.exports = __webpack_public_path__ + "static/img/nvzhujue_icon.238e426.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/nvzhujue_icon.png
// module id = QmvY
// module chunks = 1